import * as React from 'react';

import {
    Breakpoints,
    styled,
    ThemeProvider
} from '@volkswagen-onehub/components-core';

export * from './close-button';
export * from './content';

const StyledLayer = styled.div`
    --inset-position: ${props => props.theme.size.static250};

    position: absolute;
    inset: var(--inset-position);

    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    // click through to shim close
    pointer-events: none;

    // NOTE: default shim override to make it darker. In future there will be darker shim in Core.
    &:before {
        content: '';
        position: absolute;
        inset: calc(-1 * var(--inset-position));
        background: rgba(0, 0, 0, 0.7);
    }

    @media (min-width: ${Breakpoints.b960}px) {
        --inset-position: ${props => props.theme.size.static350};
    }
`;

export interface FullscreenGalleryLayerProps {
    active: boolean;
    children?: React.ReactNode;
    scrollElementRef(el: HTMLDivElement): void;
}

export const FullscreenGalleryLayer: React.FunctionComponent<
    FullscreenGalleryLayerProps
> = props => {
    const {children, scrollElementRef} = props;

    return (
        <ThemeProvider theme="inverted">
            <StyledLayer ref={scrollElementRef}>{children}</StyledLayer>
        </ThemeProvider>
    );
};
